"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _revalidate = require("revalidate");

var _emailValidator = require("email-validator");

var isValidEmail = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!(0, _emailValidator.validate)(value)) {
      return message;
    }
  };
}, function (field) {
  return field + " doesn't seem to be valid";
});

var isValidUrl = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (value && !/^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/i.test(value)) {
      return message;
    }
  };
}, function (field) {
  return field + " doesn't seem to be valid";
});

var validate = (0, _revalidate.combineValidators)({
  artworkUrl: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidUrl)("Artwork URL"),

  name: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(2))("Name"),

  email: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidEmail)("Email"),

  title: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(2))("Title"),

  tools: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(2))("Quixel Tools Used"),

  homeUrl: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidUrl)("Homepage URL"),

  artStationUrl: (0, _revalidate.composeValidators)(isValidUrl)("ArtStation URL")
});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/galleryArtworkFormValidation.js
// module id = 2972
// module chunks = 0